import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import * as Yup from 'yup';

const billingAddressSchema = Yup.object().shape({
  billingAddress: Yup.object().shape({
    postalCode: Yup.string().required('errors.required').test({
      message: 'errors.invalidPostalCode',
      name: '',
      test: function (value) {
        return String(value).replace(/\D/g, '').length === 8;
      }
    }),
    neighborhood: Yup.string().max(100).required('errors.required'),
    street: Yup.string().max(100).required('errors.required'),
    number: Yup.number().required('errors.required'),
    complement: Yup.string().max(30),
    city: Yup.string().max(50).required('errors.required'),
    state: Yup.string().max(50).required('errors.required')
  })
});

export { billingAddressSchema };
